import PaymentMethodsView from "../components/PaymentMethodsView";
import PercallTokenCard from "../components/integrations/PercallTokenCard";
import ApiTokenCard from "../components/integrations/ApiTokenCard";
import MCPTokenNotice from "../components/integrations/MCPTokenNotice";
import PrimeGatewayToken from "../components/integrations/PrimeGatewayToken";
import TechsSettings from "../components/techs/TechsSettings";
import CRMDefaultRates from "../components/techs/CRMDefaultRates";
import TechStatusAccess from "../components/techs/TechStatusAccess";
import AccountEditForm from "../../../../components/account/AccountEditForm";
import { getOwner, getUser, setOwner, setPage, setUser } from "../../../../core/Global";
import { useEffect } from "react";
import ProfileNotifications from "../../../profile/views/ProfileNotifications";
import Timezone from "../../../profile/components/preferences/Timezone";


export function EditAccountPage() {
    const user = getUser()
    return (
        <AccountEditForm userId={user?.id}
            model={user}
            onUpdate={e => setUser(e)} />
    )
}

export function EditOwnerPage() {
    const user = getUser()
    const owner = getOwner()
    if (!user?.isSystemAdmin) return null
    return (
        <AccountEditForm userId={owner?.id}
            model={owner}
            onUpdate={e => setOwner(e)} />
    )
}

export function PaymentMethodsPage() {
    return (
        <PaymentMethodsView />
    )
}

export function IntegrationsPage() {
    return (
        <>
            <PercallTokenCard />
            <ApiTokenCard title="REST Api Token"
                apiUrl="/accounts/profile/restapitoken/"
                modalId="modal-regenerate-restapitoken" />
            <ApiTokenCard title="MCP Token"
                apiUrl="/accounts/profile/mcptoken/"
                modalId="modal-regenerate-mcptoken"
                firstTimeNotice={<MCPTokenNotice />}
                firstTimeNoticeModalId="modal-mcptoken-notice"
                firstTimeNoticeTitle="Notice to Customers"
                firstTimeNoticeAcceptText="Accept & Generate Token" />
            <PrimeGatewayToken />
        </>
    )
}

export function TechsPage() {
    return (
        <>
            <TechsSettings />
            <CRMDefaultRates />
            <TechStatusAccess />
        </>
    )
}


export function NotificationHistoryPage() {
    useEffect(() => {
        setPage("Notification History", "Account", "System")
    }, [])
    return (
        <ProfileNotifications />
    )
}

// The user's personal settings. Only the time zone for now; more personal settings go here.
export function PreferencesPage() {
    useEffect(() => {
        setPage("Preferences", "Account", "System")
    }, [])
    return (
        <Timezone />
    )
}
